import './careers.scss';
import './oferta.scss';
import { getText, appendText } from '../../assets/js/text-renderer';

const API_PRO = {
  url: 'https://d2gtbf5b5cwj26.cloudfront.net/prenomics/candidates/',
  token: '0011387adc885c203809680b725c3a91b094e898',
};
const API_PRE = {
  url: 'https://intelek-api-alb-mx6faw6vaqpmqfqm2wim02cwsdbl3m.prenomics.com/prenomics/candidates/',
  token: 'e9c806daa4a7a990809dc07cce35a28d45b9b229',
};
const API = API_PRO;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const jobCode = urlParams.get('cod');

getText(`jobs/${jobCode}`)
  .then((dict) => {
    const data = dict.stories[0].content;

    if (jobCode === 'work-with-us') {
      document.getElementById('offer-content').classList.add('d-none');
      appendText(data.text, 'description');
    } else {
      appendText(data.offer, 'offer-content');
      appendText(data.description, 'description');
    }
    appendText(data.title, 'title');
  });

if (
  DEVELOPMENT || (
  window['__PRERENDER_INJECTED'] && 
  window['__PRERENDER_INJECTED'].render_text
)) {
  getText('shared/keywords').then(function (dict) {
    const texts = dict.stories[0].content;
    appendText(texts.trabajo, 'trabajo-subtitle');

    appendText(texts.quien_eres, 'quien-eres');
    appendText(texts.formulario_oferta, 'formulario-oferta');

    appendText(texts.nombre, 'nombre-l');
    appendText(texts.email, 'email-l');
    appendText(texts.telefono, 'telefono-l');
    appendText(texts.empresa, 'empresa-l');
    appendText(texts.mensaje, 'mensaje-l');
    appendText(texts.leido_politica, 'leido-politica-privacidad');
    appendText(texts.politica_privacidad, 'politica-privacidad');
    appendText(texts.acepte_politica, 'policy-accept');

    window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
    window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
    window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'cta' }));
  });
}

const formEl = document.getElementById('formEl');
const formPrivacyCheckboxEl = document.getElementById('privacidad');
const formSubmitButton = document.getElementById('form-submit');
const policyAccept = document.getElementById('policy-accept');
const successMessage = document.getElementById('success-message');

formEl.addEventListener('submit', onSubmitForm);
formPrivacyCheckboxEl.addEventListener('click', onPrivacyCheckboxClick);

function enableSubmitButton(enable) {
  if (typeof enable !== "boolean")
    throw new TypeError("The disable argument must be a boolean");

  if (enable) {
    formSubmitButton.disabled = false;
    formSubmitButton.classList.remove("disabled");
  } else {
    formSubmitButton.disabled = true;
    formSubmitButton.classList.add("disabled");
  }
}

function onPrivacyCheckboxClick() {
  if (formPrivacyCheckboxEl.checked) {
    enableSubmitButton(true);
    policyAccept.classList.add("d-none");
  } else {
    enableSubmitButton(false);
    policyAccept.classList.remove("d-none");
  }
};

function onSubmitForm(event) {
  event.preventDefault();

  if (!formPrivacyCheckboxEl.checked) {
    policyAccept.classList.remove('d-none');
    return;
  }

  const XHR = new XMLHttpRequest();
  XHR.addEventListener('load', (event) => {
    formSubmitButton.innerText = '¡Enviado!';
    successMessage.classList.remove('d-none');
  });
  XHR.addEventListener('error', (event) => {
    formSubmitButton.innerText = '¡Prueba de nuevo!';
    enableSubmitButton(true);
  });
  XHR.open('POST', API.url);
  XHR.setRequestHeader('Authorization', `Token ${API.token}`);

  // Bind the FormData object and the form element
  const FD = new FormData(formEl);

  enableSubmitButton(false);
  formSubmitButton.innerText = 'Enviando...';
  XHR.send(FD);

  return false;
}

